<!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
<template>
  <v-app id="admin">
    <!-- <auth></auth> -->
    <brandbar_admin></brandbar_admin>
    <v-container id="users_list" class="mt-10">
      <v-row no-gutters>
        <v-col cols="12" md="12" class="users_expansion">
          <!-- Expansion Panels -->
          <v-expansion-panels v-model="panel">
            <!-- names Expansion Panel -->
            <v-expansion-panel class="mb-3">
              <v-expansion-panel-header
                class="users_expansion white--text rounded-b-0 mb-3"
              >
                NIBRS REVIEW ADMIN
                <template v-slot:actions>
                  <v-icon color="white" x-large> $expand </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content color="cmpbkinside">
                <v-row>
                  <v-col>
                    <!-- Card -->
                    <v-card
                      class="mb-3 border-barbexpand person-card"
                      dark
                      elevation="2"
                      outlined
                      v-for="(person, index) in lst_persons"
                      :key="index"
                    >
                      <v-card-title class="title-name">{{
                        person.user_name
                      }}</v-card-title>
                      <v-card-text class="card-text">
                        <h6 class="sub-title">Email:</h6>

                        <p>{{ person.email }}</p>
                        <h6 class="sub-title">Last Certification Date</h6>
                        <p>{{ person.last_cert_date }}</p>

                        <!-- SELECT AND BUTTON -->
                        <v-row class="btn-row">
                          <v-col>
                            <div
                              class="submit-btn mt-3 d-flex flex-md-row flex-column justify-md-space-between align-center"
                            >
                              <v-checkbox
                                id="select_user"
                                v-model="select_user"
                                required
                                :color="isChecked ? 'grey' : 'greenbtn'"
                              >
                                <template v-slot:label>
                                  <span class="custom-label">Select User</span>
                                </template>
                              </v-checkbox>
                              <v-btn
                                dark
                                class="mb-2 barbexpand black--text"
                                @click="del_prompt(person)"
                                >Delete</v-btn
                              >
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style lang="scss" scoped>
/* 0 media q */
@media (min-width: 0px) {
  .person-card {
    border-color: #669888;
  }

  .title-name {
    font-size: 1.25rem;
  }

  .sub-title {
    font-size: 1rem;
  }

  .custom-label {
    color: #22f1bf;
    font-size: 1.5rem;
  }
  .btn-row {
    width: 90%;
    margin: 0 auto;
  }

  .users_expansion {
    height: 48px;
    width: 100%;
    margin: 0 auto;
    background-color: #708e92;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }

  .users_expansion p {
    font-size: 0.9375rem;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .users_expansion button {
    font-size: 1.5rem;
  }
  .title-name {
    font-size: 1.75rem;
  }

  .card-text p {
    font-size: 1.5rem;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
import brandbar_admin from "./brandbar_admin.vue";
// import auth from "./auth.vue";
export default {
  name: "admin",
  // put 'auth' back inot components
  components: { brandbar_admin },
  mixins: [bus_common],
  data() {
    return {
      value: "",
      panel: 0,
      valid: false,
      authed: false,
      lst_persons: [
        {
          user_name: "Friday, J",
          email: "joe@example.com",
          last_cert_date: "04/23/2025",
        },
        {
          user_name: "Starsky, D",
          email: "starsky@example.com",
          last_cert_date: "04/18/2025",
        },
        {
          user_name: "Kojak, T",
          email: "kojak@example.com",
          last_cert_date: "03/23/2025",
        },
      ],
      select_user: false,
    };
  },
  computed: {},

  /* METHODS */
  methods: {
    del_prompt(person) {
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting the User '" +
          person.f_name +
          " " +
          person.l_name +
          "'. Do you wish to continue?",
        "question",
        function () {
          self.delnow(person);
        },
        null,
        null,
        function () {}
      );
    },
    delnow(person) {
      console.log("delnow");
      //validate

      this.show_loader(true);
      let formIn = {};

      formIn.gym_waiverId = person.gym_waiverId;
      formIn.apiname = "delnow";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.get_waivers();
          this.show_loader(false);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error PW", msg, "error", null, null);
        });
    },
    get_waivers() {
      console.log("get_waivers");
      //validate

      this.show_loader(true);
      let formIn = {};

      formIn.apiname = "";

      let self = this;
      this.$store
        .dispatch("get_waivers", formIn)
        .then((data) => {
          console.log(data[0].l_name);
          self.lst_waivers = self.mno(data);
          self.lst_waivers.forEach((element) => {
            element.submit_date = self.format_date_us(element.submit_date);
          });
          this.show_loader(false);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error PW", msg, "error", null, null);
        });
    },

    message1() {
      alert("This button does nothing yet.");
    },

    message2() {
      alert("This button also does nothing yet.");
    },

    init() {
      // this.get_waivers();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
